import React, { useEffect, useRef, useState } from 'react';
import Modal from 'react-modal';
import Janus from 'janus-gateway';
import { Icon, Loader, MobileSkin, Tooltip, Button } from 'fireflink-ui';
import { getUpdatedExecutionData } from '@api/api_services';
import { colors } from '@src/css_config/colorConstants';
import { getTruncatedText } from '@src/util/common_utils';
import adapter from 'webrtc-adapter';
import Draggable from 'react-draggable';
import './mobile_modal.scss';

const MobileLiveVideoModal = (props) => {
  const videoRef = useRef(null);
  const janusDeps = Janus.useDefaultDependencies({ adapter });

  const [janusUrl, setJanusUrl] = useState('');
  const [streamID, setStreamID] = useState();
  const [errorMsg, setErrorMsg] = useState('');
  const [openModal] = useState(true);
  const [isMaximize, setIsMaximize] = useState(false);
  const [executionStatus, setExecutionStatus] = useState(false);
  const [videoLoaded, setVideoLoaded] = useState(false);
  const timerId = useRef(null);
  const janusInstance = useRef(null);
  const streamingPlugin = useRef(null);
  const [isOpen, setIsOpen] = useState(true);
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setIsOpen(true);
        props.closeDeviceModal(false);
      }
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, props]);

  const getStreamId = async (isOneTimeCall) => {
    try {
      const res = await getUpdatedExecutionData(props.liveExecutionPayload);
      const { responseObject, status, responseCode } = res?.data || {};

      const janusURL = responseObject?.JanusSever;
      const streamID = responseObject?.streamID;

      setJanusUrl(janusURL);
      setStreamID(streamID);

      if (responseCode === 404) {
        setErrorMsg('Something went wrong');
      } else if (['Execution Completed', 'Execution Failed'].includes(status)) {
        setExecutionStatus(true);
        setErrorMsg(status);
        setTimeout(() => {
          props.closeDeviceModal();
        }, 3000);
      } else if (status === 'Script execution not yet started') {
        setErrorMsg(status);
      }

      if (
        responseCode === 404 ||
        ['Execution Completed', 'Execution Failed', 'Execution not yet started'].includes(status)
      ) {
        if (!isOneTimeCall) {
          clearInterval(timerId.current);
        }
      }
    } catch (err) {
      console.error('Error fetching stream ID:', err);
      setErrorMsg('Something went wrong while fetching execution data.');
      if (!isOneTimeCall) {
        clearInterval(timerId.current);
      }
    }
  };

  // Initialize Janus and start streaming
  async function createJanusSession(janusUrl, streamID) {
    let janus = null;
    let streamingPluginLocal = null;
    // Initialize Janus
    Janus.init({
      debug: 'all',
      dependencies: janusDeps,
      callback: () => {
        janus = new Janus({
          server: janusUrl,
          success: () => {
            janus.attach({
              plugin: 'janus.plugin.streaming',
              success: (pluginHandle) => {
                streamingPluginLocal = pluginHandle;
                streamingPlugin.current = pluginHandle;
                streamingPluginLocal.send({
                  message: { request: 'watch', id: streamID },
                });
              },
              onmessage: (msg, jsep) => {
                if (jsep) {
                  streamingPluginLocal.createAnswer({
                    jsep,
                    media: { audioSend: false, videoSend: false },
                    success: (jsepAnswer) => {
                      streamingPluginLocal.send({
                        message: { request: 'start' },
                        jsep: jsepAnswer,
                      });
                    },
                    error: (error) => {
                      console.error('Error creating answer:', error);
                    },
                  });
                }
              },
              onremotetrack: (track, mid, on) => {
                if (!on || !videoRef.current) return;
                if (track.kind === 'video') {
                  const stream = videoRef.current.srcObject || new MediaStream();
                  stream.addTrack(track);
                  videoRef.current.srcObject = stream;
                }
              },
              error: (error) => {
                console.error('Error attaching plugin:', error);
              },
            });
          },
          error: (error) => {
            console.error('Janus error:', error);
          },
          destroyed: () => {
            console.info('Janus destroyed');
          },
        });
      },
    });
    return () => {
      if (janus) janus.destroy();
    };
  }
  const isVideoReady = videoRef.current !== null;





  useEffect(() => {
    const fetchAndSetupWebSocket = async () => {
      const isOneTimeCall = true;
      await getStreamId(isOneTimeCall);
      if (janusUrl && streamID) {
        createJanusSession(janusUrl, streamID);
      }
    };

    fetchAndSetupWebSocket();
    timerId.current = setInterval(() => getStreamId(false), 2000);

    return () => {
      clearInterval(timerId.current);
      if (janusInstance.current) {
        janusInstance.current.destroy();
      }
    };
  }, [janusUrl, streamID]);

  const loadingVideo = () => (
    <p className="fontPoppinsRegularMd video-loading">
      Video is getting loaded <Loader variant="BouncingDots" />
    </p>
  );

  const loadingliveVideo = () => (
    <p
      className="fontPoppinsRegularMd"
      style={{ margin: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      Video is getting loaded <Loader variant="BouncingDots" />
    </p>
  );

  function handleOnCloseChange() {
    setIsOpen(true);
    if (videoRef.current) {
      videoRef.current.srcObject = null;
    }
    props.closeDeviceModal(false);
  }

  const showMobileData = () => {
    if (!isOpen) return null;

    if (props.liveExecutionPayload.type !== 'web') {
      return (
        <Draggable>
          <div ref={modalRef} className="mobilemodal-container">
            <div className="mobilevideo-container">
              <MobileSkin
                mobileHeight={448}
                mobileWidth={220}
                style={{ width: '100%', position: 'relative', overflow: 'hidden' }}
                orientation="portrait"
              >
                 <>
                  <video ref={videoRef} autoPlay playsInline className="mobilevideo-stream" />
                  {isVideoReady && <p className="mobileerror-message">{errorMsg || loadingVideo()}</p>}
                </>
              </MobileSkin>
              <Icon
                name="dismiss_icon"
                onClick={handleOnCloseChange}
                color={colors.text_black}
                height={24}
                width={24}
                className="mobileclose_icon"
              />
            </div>
          </div>
        </Draggable>
      );
    } else {
      return (
        <Modal
          shouldCloseOnEsc={false}
          isOpen={true}
          className="focus:outline-none vnc-modal-content"
          onRequestClose={handleOnCloseChange}
        >
          <div className="vnc-modal-header">
            <Tooltip title={props.selectedScriptName}>
              <span className="vnc-modal-header-text">
                {getTruncatedText(props.selectedScriptName)}
              </span>
            </Tooltip>
            <div className="vnc-modal-header-icons">
              {videoLoaded && (
                <Tooltip title={isMaximize ? 'Minimize' : 'Maximize'} placement="bottom">
                  <Icon
                    name={isMaximize ? 'close_fullscreen' : 'open_fullscreen'}
                    className="cursor-pointer"
                    onClick={() => setIsMaximize((prev) => !prev)}
                    height={24}
                    width={24}
                    color={colors.text_black}
                  />
                </Tooltip>
              )}
              <Tooltip title="Close" placement="bottom">
                <Icon
                  className="cursor-pointer"
                  onClick={handleOnCloseChange}
                  name="dismiss_icon"
                  height={24}
                  width={24}
                  color={colors.text_black}
                />
              </Tooltip>
            </div>
          </div>
          <div className={`vnc-viewer--${isMaximize ? 'maximize' : 'minimize'}`} style={{ position: 'relative' }}>
            <video
              ref={videoRef}
              autoPlay
              playsInline
              onLoadedData={() => setVideoLoaded(true)}
              style={{ width: '100%', height: '100%', position: 'absolute' }}
            />
            {!videoLoaded && (
              <div
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  zIndex: 2,
                  padding: '10px',
                  borderRadius: '8px',
                }}
              >
{errorMsg || loadingliveVideo()}              </div>
            )}
          </div>
          <div className="vnc-modal-bottom">
            <Button variant="secondary" label="Cancel" size="small" onClick={handleOnCloseChange} />
          </div>
        </Modal>
      );
    }
  };

  return showMobileData();
};

export default MobileLiveVideoModal;
